module.exports = __webpack_public_path__ + "f80d10f65143ea963ead7813f28d626c.png";